import { graphql } from "@apollo/client/react/hoc";
import { flowRight as compose } from "lodash";
import * as React from "react";
import { RouteComponentProps, Switch, Route, Redirect, NavLink, withRouter } from "react-router-dom";
import Text from "components/LegacyText";
import Icon from "components/Icon";
import { GigFull } from "interfaces/Gig";
import checkIcon from "assets/check.svg";
import variables from "styles/variables";
import { articles } from "../../../articles";
import gigDetailsQuery from "./gigDetails.gql";
import Report from "../../Report";
import Support from "./Support";
import styles from "./styles.scss";
import ReportHeader from "../Header";
import { UiCustomization } from "gql-gen";
import { getAppUrl } from "utilities/routes";
interface Props extends RouteComponentProps {
  data: {
    loading: boolean;
    error: any;
    gig: {
      location: string;
      managerOrganization: {
        id: string;
        name: string;
        uiCustomization: UiCustomization;
      };
      talentOrganization: {
        id: string;
        name: string;
      };

      products: Array<{}>;
      startTime: string;
      title: string;
      timezone: string;
      compareWorkflowStateOrder: number;
    } & GigFull;

    me: { id: string; isAdmin: boolean };
    refetch: () => Promise<void>;
  };

  className?: string | null;
}

function GigInfo(props: Props) {
  const {
    match: { path, url },
    data: { loading, gig, me, refetch },
    location,
  } = props;

  if (gig && me && gig.talent && gig.talent.id !== me.id && !me.isAdmin) {
    return (
      <React.Fragment>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <Text.P kind="reverse" className={styles.gigTitle}>
              GoGetter Report Link
            </Text.P>
          </div>
        </div>

        <div className={styles.errorMessage}>
          <Text.P2>This link is meant only for the assigned GoGetter</Text.P2>

          <Text.P4 kind={"secondary"} className={styles.errorExplanation}>
            <br />
            <br />
            Only GoGetters who are assigned to this gig may use this report link.
            <br />
            <br />
            You can share this with your assigned GoGetter and they’ll be able to complete the report.
            <br />
            <br />
            If you are the manager of this gig and wish to view or edit the field report, please click review ({" "}
            {<Icon src={checkIcon} size={16} fill={variables.teal1} />}) under Needs Review.
            <br />
            <br />
            Want more info? See{" "}
            <Text.NewLink4 href={articles.agenciesVerifyingReports}>instructions for agencies</Text.NewLink4> or{" "}
            <Text.NewLink4 href={articles.clientsVerifyingReports}> instructions for clients</Text.NewLink4>.
          </Text.P4>
        </div>
      </React.Fragment>
    );
  }

  const isTalent = gig?.talent?.id === me?.id;

  const agencyName = gig?.talentOrganization?.name;
  const client = gig?.managerOrganization;
  const clientName = client?.name;
  const orgId = (props.match.params as any).orgId;
  const goBackUrl = orgId ? getAppUrl("go", `${orgId}/tasks/${gig?.id}`) : getAppUrl("go");

  return (
    <React.Fragment>
      <ReportHeader
        agencyName={agencyName}
        clientName={clientName}
        logoUrl={client?.uiCustomization?.squareLightBgLogoUrl}
        gig={gig}
        goBackUrl={goBackUrl}
      />

      {(loading || isTalent) && (
        <Switch>
          <Route path={path + "/report"} render={props => <Report gig={gig} gigRefetch={refetch} {...props} />} />
          <Route
            path="*"
            render={() => {
              window.location.href = goBackUrl;
              return null;
            }}
          />
        </Switch>
      )}
    </React.Fragment>
  );
}

export default compose(
  withRouter,
  graphql<any, any, any, any>(gigDetailsQuery, {
    options: props => {
      return {
        variables: {
          gigId: props.match.params.id,
          applyHash: props.match.params.hash,
          compareToKey: "reportDraft",
        },
        fetchPolicy: "no-cache",
      };
    },
  }),
)(GigInfo);
